import { render, staticRenderFns } from "./AddModelosPage.vue?vue&type=template&id=8b1d7a02"
import script from "./AddModelosPage.vue?vue&type=script&lang=js"
export * from "./AddModelosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports